const COOKIE_NAME = 'odyssey_referral';
const MAX_LENGTH = 50;
const VALID_PATTERN = /^[a-zA-Z0-9-]+$/;
const ALLOWED_REFERRALS = ['LiveEasy', 'MovePlus'];

function normalizeAllowedReferral(value) {
    const lowerValue = value.toLowerCase();
    return ALLOWED_REFERRALS.find(allowed => allowed.toLowerCase() === lowerValue) || null;
}

function sanitize(value) {
    if (!value || typeof value !== 'string') return null;
    const trimmed = value.trim().substring(0, MAX_LENGTH);
    if (!VALID_PATTERN.test(trimmed)) return null;
    return normalizeAllowedReferral(trimmed);
}

export function saveReferralCookie(referralSource) {
    const sanitized = sanitize(referralSource);
    if (!sanitized) return;
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(sanitized)}; path=/; SameSite=Lax; max-age=31536000`;
}

export function getReferralCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    if (!match) return null;

    const sanitized = sanitize(decodeURIComponent(match[1]));

    if (!sanitized) {
        clearReferralCookie();
        return null;
    }

    return sanitized;
}

export function clearReferralCookie() {
    document.cookie = `${COOKIE_NAME}=; path=/; SameSite=Lax; max-age=0`;
}

export function captureReferralFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && !getReferralCookie()) {
        saveReferralCookie(ref);
    }
}
